import { Navigate, useLocation } from "react-router-dom";
import { rememberPostLoginTarget } from "@/utils/postLoginRedirect";

/**
 * Bounce to the login screen while remembering where the user was going, so a deep
 * link (notably a GG notification's /chat?room=<id>) survives the detour.
 *
 * The write happens during render on purpose: <Navigate> performs its redirect from
 * its own effect, which runs before this component's would, so an effect here would
 * be too late.
 */
export function RedirectToLogin() {
  const location = useLocation();
  rememberPostLoginTarget(location.pathname + location.search);
  return <Navigate to="/auth/login" replace />;
}
